import { IonContent, IonHeader, IonPage } from '@ionic/react';
import { useUser } from '@tbitop/authentication';
import { ApplicationHeader, Header3 } from '@tbitop/ui';
import { isUndefined } from 'lodash-es';
import type { PropsWithChildren } from 'react';
import { useSideMenu } from './mobile-side-menu';
import { Refresher } from './refresher';

type PageComponentProps = {
  onPullToRefresh?: () => Promise<unknown>;
  title?: string;
};

export const MobilePage = ({ children, title, onPullToRefresh }: PropsWithChildren<PageComponentProps>) => {
  const user = useUser();
  const openSideMenu = useSideMenu();

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <ApplicationHeader onNavigationProfileClick={openSideMenu} user={user}>
          <Header3 className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap">{title}</Header3>
        </ApplicationHeader>
      </IonHeader>

      <IonContent forceOverscroll={false}>
        {!isUndefined(onPullToRefresh) ? <Refresher onRefresh={onPullToRefresh} /> : null }
        <main className="mx-200 md:mx-400">
          {children}
        </main>
      </IonContent>
    </IonPage>
  );
};

